<template>
<section class="container">
  <section class="out_box">
    <section class="qrcode_box">
      <h2>{{$route.query.couponType|couponType}}二维码</h2>
      <span class="num">{{$route.query.bindCount}}张</span>
      <section class="tips_box">
        <span class="dashed"></span>
        <p>对准二维码扫一扫并领取</p>
      </section>
      <div class="img" ref="qrCodeUrl"></div>
      <p class="time">二维码3分钟内有效</p>
    </section>
  </section>
</section>
</template>
<script>
import {mapState} from 'vuex'
import {serversHttp } from '../../utils/api'
import QRCode from 'qrcodejs2'
export default {
  name: 'qrcodeDispatch',
  props: {

  },
  filters:{
    couponType(val){
      if(val == 1){
        return '免费券'
      }else if(val == 2){
        return '金额券'
      }else if(val == 3){
        return '时间券'
      }else{
        return '折扣券'
      }
    },
  },
  components: {
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data() {
    return {
    }
  },
  created(){
    let text = '';
    var localpageURL = window.window.location.href
    var arr = localpageURL.split('?')
    if(arr.length>0){
       localpageURL = arr[0];
       localpageURL = localpageURL.replace("qrcodeDispatch","")
    }
   // "qrcodeDispatch"
    if(this.common.marketInfo.cityId == '5'){
      text = 'https://h5.topchainspace.com/getParkingCoupon?scene='+this.$route.query.scene+'&marketId='+this.common.marketInfo.id;
    }else{
      text = localpageURL + 'getParkingCoupon?scene='+this.$route.query.scene+'&marketId='+this.common.marketInfo.id;
      //text = serversHttp.replace("spaceuprstapi","spaceuph5")+'getParkingCoupon?scene='+this.$route.query.scene+'&marketId='+this.common.marketInfo.id;
    }
    console.log("textURL === "  +text)
    this.$nextTick(()=>{
      this.creatQrCode(text)
    })
  },
  methods:{
    //js生成二维码
    creatQrCode(text) {
      if(!this.qrcodeTool){
        var wh =document.body.clientWidth;
        var w =150*wh/375;
        var h =150*wh/375;
        this.qrcodeTool = new QRCode(this.$refs.qrCodeUrl, {
          text: text ,
          //JSON.stringify(map).replace(/(\")/g,"\\$1"),
          width: w,
          height: h,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.M
        })
      }else{
        this.qrcodeTool.clear(); // 清除代码
        this.qrcodeTool.makeCode(text); // 生成另外一个二维码
      }
    },
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.container{
  background: #f3f4f6;
}
// overflow:hidden;隐藏的是border以内的内容，隐藏不包括border.
.out_box{
  overflow: hidden;
  margin:40px;
}
.qrcode_box{
  background:rgba(255,255,255,1);
  border:1px solid rgba(218,218,218,1);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
  h2{
    font-size:36px;
    color:rgba(51,51,51,1);
    line-height:50px;
    margin:60px 0 20px;
    text-align: center;
  }
  .num{
    display: inline-block;
    width:100px;
    height:44px;
    background:rgba(23,64,218,1);
    border-radius:22px;
    font-size:24px;
    color:rgba(255,255,255,1);
    line-height:44px;
    text-align:center;
    margin:0 auto 42px;
  }
  .tips_box{
    position: relative;
    height:68px;
    width:100%;
    .flex();
    justify-content: center;
    align-items: center;
    &::before{
      position: absolute;
      top:50%;
      left:-15px;
      width:28px;height:28px;
      border:1px solid rgba(218,218,218,1);
      transform: translateY(-50%);
      background:#f3f4f6;
      z-index:2;
      content:'';
      border-radius: 100%;
    }
    &::after{
      position: absolute;
      top:50%;
      right:-15px;
      width:28px;height:28px;
      border:1px solid rgba(218,218,218,1);
      transform: translateY(-50%);
      background:#f3f4f6;
      z-index:2;
      content:'';
      border-radius: 100%;
    }
    p{
      line-height:68px;
      text-align:center;
      position: relative;
      z-index:2;
      display: inline-block;
      padding:0 20px;
      background:#fff;
      font-size:28px;
      color:rgba(23,64,218,1);
    }
    .dashed{
      width:100%;
      height:1px;
      border-top:1px dashed #dadada;
      position: absolute;
      top:50%;left:50%;
      transform: translate(-50%,-50%);
    }
  }
  .img{
    display:block;
    width:300px;
    height:300px;
    padding:20px;
    border-radius:8px;
    border:2px solid rgba(218,218,218,1);
    margin:60px 0 28px;
    overflow: hidden;
  }
  .time{
    font-size:28px;
    color:rgba(102,102,102,1);
    line-height:40px;
    margin-bottom: 118px;
    text-align: center;
  }
}
</style>
